<template>
  <div class="component_memberCard" v-if="loaded">
    <div class="cardFaceBox" v-bind:style="{ color: card.fontColor }" v-if="datas.isHideCard!=true">
      <img :src="faceAttr" alt="" class="cardFace">
      <p class="cardDesc" v-if="!closeCardInfo">{{currentCard.cardLevelDescript}} {{currentCard.cardNo}}</p>
      <div class="cardInfo">
        <p class="cardTime" v-if="memberValidityType!='1'&&!closeCardInfo">{{memberValidityType=="2"?currentCard.endLevelDate:currentCard.dateEnd}}到期</p>
        <!-- <div class="changeCard" @click="toggleMultiCard" v-if="user&&user.cardListDto&&user.cardListDto.length>1&&hideCardSwitch!=='T'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" class="changeIcon"><path d="M3 6.899a.3.3 0 0 1 .298-.299h5.404A.298.298 0 0 1 9 6.9c0 .166-.137.3-.298.3H4.007L5.21 8.403a.299.299 0 0 1 0 .424.302.302 0 0 1-.424 0L3.087 7.13A.297.297 0 0 1 3 6.899ZM8.995 4.75a.301.301 0 0 1-.293.35H3.297a.298.298 0 0 1-.298-.3c0-.166.137-.3.298-.3h4.78L6.79 3.21a.299.299 0 0 1 .001-.423.301.301 0 0 1 .423 0l1.7 1.7c.069.069.1.167.082.263Zm2.55 3.547a6 6 0 1 0-3.248 3.248.3.3 0 0 0-.23-.554 5.4 5.4 0 1 1 2.923-2.924.3.3 0 0 0 .555.23Z" fill-rule="nonzero" :fill="fillColor" data-follow-fill="#E4C3A8" /></svg>切换卡
        </div>
        <div class="toggleRight" @click="changeRights" v-bind:style="{color:datas.cardBtTextColor,background:datas.cardBtColor}">{{datas.isMemberRight=='T'?"收起权益":"展开权益"}}</div> -->
      </div>
    </div>
    <!-- <div v-if="datas.isMemberRight=='T'&&icons.length>0" class="iconWrapper" v-bind:style="{background:datas.bgColor}">
      <div class="topBox">
        <div class="titleBox" :class="datas.btPosition">
          <p class="title" v-bind:style="{color:datas.titleColor}">{{datas.title?datas.title:"您可享受的权益"}}</p>
          <p class="subTitle" v-bind:style="{color:datas.btColor}" @click="seeMemberRightInfo(datas)">{{datas.btText?datas.btText:"查看会员权益章程"}}</p>
        </div>
        <div class="seeMore" @click="goRouter('memberRightsNew')" v-bind:style="{color:datas.moreColor}">查看更多></div>
      </div>
      <div class="iconList" v-bind:class="{ 'style2' : datas.style == 2 }">
        <div class="iconBox" v-for="(icon,iconIndex) in icons" :key="iconIndex" @click="showInfo(icon)" :class="rowClass">
          <img :src="icon.iconUrl" alt="" class="icon">
          <div class="titleWrapper">
            <p class="title">{{icon.name}}</p>
            <p class="subtitle">{{icon.remark}}</p>
          </div>
        </div>
      </div>
    </div> -->
    <right-infobox ref="rightInfobox" :title="title" :info="info"></right-infobox>
  </div>
</template>
<script>
import moment from "moment";
import api from "@/utils/api";
import { jAlert3 } from "@/base/jAlert/jAlert";
import { urlEncode } from "@/utils/index";
import { setStorage, getStorage } from "@/utils/wxuser";
import rightInfobox from "@/components/rightInfoBox";

var config = {};
export default {
  data() {
    return {
      user: getStorage("user"),
      wxuser: getStorage("wxuser"),
      currentCardIndex: 0,
      currentCard: {},
      card: {},
      title: "",
      info: "",
      rowClass: "row4",
      icons: [],
      faceAttr:"",
      loaded:false,
      fillColor:"#e4c3a8",
      memberValidityType:"",
    };
  },
  props: ["datas"],
  components: {
    rightInfobox,
  },
  /* inject: ["isHideCardSwitch","getMemberValidityType"], */
  methods: {
    getfunctionControl() {
      var codes = ["memberValidityType"];
      var self = this;
      var params = {
        appid: config.appid,
        codes: codes.join(","),
        componentAppid: config.componentAppid,
        hotelCode: config.hotelCode ? config.hotelCode : 0,
        hotelGroupCode: config.hotelGroupCode,
        clientType: "wechat",
      };
      api
        .getMultiSysOptionCommon(params)
        .then((data) => {
          if (data.result == 1) {
            data.retVal.forEach(function (n, i) {
              if (n.code == "memberValidityType" && n.value) {
                self.memberValidityType = n.value;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    seeMemberRightInfo(datas){
      if(!datas.btContent){
        return false;
      }
      let rule = {
        title:datas.btText,
        desc:datas.btContent,
      }
      setStorage("rule",rule);
      var obj = {
        type:"storage"
      };
      this.$router.push({
        path: "/codeText",
        name: "codeText",
        query: obj,
      });
    },
    changeRights(){
      if(this.datas.isMemberRight == "T"){
        this.datas.isMemberRight = "F";
      }else{
        this.datas.isMemberRight = "T";
      }
    },
    toggleMultiCard(){
      this.$emit("toggle-multiCard");
    },
    showInfo(icon) {
      if(icon&&icon.descriptUrl){
        this.goUrl(icon.descriptUrl);
        return false;
      }
      this.title = icon.name;
      this.info = icon.descript;
      this.$refs.rightInfobox.show();
    },
    setDefault(){
      this.faceAttr = this.card.faceAttr||'https://xcx.ihotel.cn/customMemberCenter/images/memberCard.png';
      this.loaded = true;
    },
    membercardInterestDesc() {
      api
        .membercardInterestDesc({
          cardCode: this.currentCard.cardLevel,
          hotelGroupCode: config.hotelGroupCode,
          hotelCode: config.hotelCode,
        })
        .then((res) => {
          if (res.result == 1) {
            if (res.retVal && res.retVal.cardCode) {
              if (res.retVal.rowNum) {
                this.rowClass = `row${res.retVal.rowNum}`;
              }
              if (res.retVal.icons) {
                let icons = (icons = JSON.parse(res.retVal.icons).filter(
                  (n) => n.name !== "全部权益"
                ));
                this.icons = icons;
              }
              this.card = res.retVal;
              this.fillColor = this.card.fontColor||"#e4c3a8";
              this.setDefault();
            }else{
              this.setDefault();
            }
          } else {
            this.setDefault();
          }
        });
    },
  },

  created() {
    config = getStorage("config");
  },
  mounted() {
    if (this.user && this.user.memberId) {
      [this.currentCard, this.currentCardIndex] = this.getCurrentCard();
      if (this.currentCard.endLevelDate) {
        this.currentCard.endLevelDate = moment(this.currentCard.endLevelDate).format('YYYY-MM-DD')
      }
      this.membercardInterestDesc();
      this.getfunctionControl();
    }
  },
  beforeDestroy() {},
  computed: {
    /* hideCardSwitch(){
      return this.isHideCardSwitch();
    },
    memberValidityType(){
      return this.getMemberValidityType();
    }, */
    closeCardInfo(){
      let closeCardInfo = false;
      if(this.datas&&this.datas.closeCardInfo){
        closeCardInfo = this.datas.closeCardInfo;
      }
      return closeCardInfo;
    }
  },
  watch: {},
};
</script>
<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/skin.less");
@import url("~@/styles/mixin.less");
.component_memberCard {
  width: calc(~"100vw - 30px;");
  margin: 0 auto;
  margin-bottom: 15px;
  .iconWrapper{
    background: #ffffff;
    box-shadow: 0px 2px 10px -3px rgba(0, 0, 0, 0.11);
    border-radius: 6px;
    transition: all 0.5s;
    .topBox{
      height:70px;
      position: relative;
      padding:0 10px;
      .seeMore{
        position: absolute;
        right:10px;
        top:15px;
        color: #999999;
      }
      .titleBox{
        display: flex;
        flex-direction: column;
        justify-content: center;
        height:100%;
        &.center{
          align-items: center;
        }
        .title{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          margin-bottom:10px;
        }
        .subTitle{
          font-size: 12px;
          color: @color-theme;
        }
      }
    }
  }
  .cardFaceBox {
    height: 150px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 15px;
    color: #e4c3a8;
    position: relative;
    .cardFace {
      width: 100%;
      height: 100%;
    }
    .cardDesc {
      position: absolute;
      font-size: 18px;
      left: 15px;
      top: 20px;
    }
    .cardInfo {
      height: 20px;
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      top:-40px;
      padding:0 15px;
      .cardTime {
        font-size: 12px;
      }
      .changeCard {
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 12px;
        position: absolute;
        top:-100px;
        right:15px;
        .changeIcon {
          height: 12px;
          width: 12px;
          margin-right: 5px;
        }
      }
      .toggleRight{
        background: #DEBEA3;
        border-radius: 3px;
        width:62px;
        height:22px;
        text-align: center;
        line-height: 22px;
        font-size: 12px;
        color: #333333;
      }
    }
  }
  .iconList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &.style2{
      padding:0 10px;
      .iconBox{
        width:calc(~"(100% - 16px) / 3");
        flex-direction:initial;
        background: #F9F9F9;
        border-radius: 6px;
        height:50px;
        margin-right:8px;
        margin-bottom:10px;
        padding:6px;
        flex:initial;
        text-align: left;
        &.row5,&.row4,&.row3{
          flex:initial;
        }
        &:nth-of-type(3n){
          margin-right:0px;
        }
        .icon{
          height:30px;
          width:30px;
          margin-right: 5px;
        }
        .titleWrapper{
          width:calc(~"100% - 40px");
          .title{
            margin-top:3px;
            .textHidden();
          }
        }
      }
    }
    .iconBox {
      flex: 0 0 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 116px;
      text-align: center;
      &.row3 {
        flex: 0 0 33.3333%;
        .title {
          font-size: 14px;
        }
        .subtitle {
          font-size: 12px;
        }
      }
      &.row5 {
        flex: 0 0 20%;
        .icon {
          height: 35px;
          width: 35px;
          object-fit: cover;
        }
        .title {
          font-size: 10px;
        }
        .subtitle {
          font-size: 8px;
        }
      }
      .icon {
        height: 45px;
        width: 45px;
        object-fit: cover;
      }
      .title {
        font-size: 12px;
        color: #111111;
        margin-top: 10px;
      }
      .subtitle {
        font-size: 10px;
        color: #999999;
        margin-top: 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/polymerization/memberCard.vue